import { LinkIcon } from "@heroicons/react/24/solid";

export const Link = ({ href, title }: { href: string; title?: string }) => {
    return (
        <a
            href={href}
            role="button"
            className="link-memo"
            target="_blank"
            rel="noreferrer"
        >
            <span className="inline-flex items-center gap-2">
                {title && (
                    <span className="ui-label max-w-[90px] truncate">
                        {title}
                    </span>
                )}
                <LinkIcon className="size-4 shrink-0" />
            </span>
        </a>
    );
};
